// eslint-disable-next-line no-restricted-imports
import {Button as RawButton, Flex} from 'exsportia-components'
import {ComponentProps, FC, PropsWithChildren, useCallback, useMemo} from 'react'

import {Loader} from '../loader/loader'
import {buttonStylesMap} from './settings'

type Props = {
  type?: 'cancel' | 'flat_short' | 'flat' | 'icon' | 'primary_green' | 'primary' | 'secondary'
  icon?: string
  onClick?: ComponentProps<typeof RawButton>['onClick']
  disabled?: boolean
  isLoading?: boolean
  isRightIcon?: boolean
  settings?: ComponentProps<typeof RawButton>['settings']
}

export const Button: FC<PropsWithChildren<Props>> = ({
  icon,
  type = 'primary',
  children,
  onClick,
  isRightIcon = false,
  disabled = false,
  isLoading = false,
  settings = {},
}) => {
  const settingsToUse = useMemo(() => buttonStylesMap[type], [type])
  const onClickToUse = useCallback((e: Event) => !isLoading && onClick?.(e), [onClick, isLoading])
  const childrenToUse = useMemo(
    () => (isLoading ? <Loader type={type === 'primary' ? 'contrast' : 'default'} /> : children),
    [children, isLoading],
  )

  return (
    <RawButton
      {...settingsToUse}
      settings={{...settingsToUse.settings, ...settings}}
      disabled={disabled}
      onClick={onClickToUse}
      icon={icon}
      additionalStyles={isRightIcon ? ['iconRight'] : []}
    >
      <Flex opacity={disabled || isLoading ? 0.5 : 1}>{childrenToUse}</Flex>
    </RawButton>
  )
}
